export enum PersonType {
  Candidate = 'Candidate',
  Expert = 'Expert',
  Internal = 'Internal',
  Undefined = 'Undefined'
}
